module.exports = __webpack_public_path__ + "img/light rain.63adf361.jpg";